import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { WEB_CONFIG, WebAppEnvironment } from '@buspro/web/core';
import { Observable } from 'rxjs';

/**
 * Mirrors the backend StandardPlaceImpactDto. Hand-rolled HttpClient call
 * (same pattern as AdminDashboardApiService) because the generated
 * StandardPlacesApi predates this endpoint; the next `pnpm generate-api`
 * against a backend that serves it can replace this with the typed client.
 */
export interface StandardPlaceImpact {
  companies: number;
  tenantPlaces: number;
  routes: number;
  subRoutes: number;
  busStops: number;
  activeOperations: number;
  liveFutureBookings: number;
}

@Injectable({ providedIn: 'root' })
export class StandardPlaceImpactService {
  private http = inject(HttpClient);
  private environment = inject<WebAppEnvironment>(WEB_CONFIG);

  getImpact(standardPlaceId: string): Observable<StandardPlaceImpact> {
    return this.http.get<StandardPlaceImpact>(`${this.environment.api}/standard-places/${standardPlaceId}/impact`);
  }
}
